import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function About() {
  return (
    <div className="bg-cream grain pt-32 pb-24">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60">— Chi sono</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal>
              <h1 className="font-heading text-6xl md:text-8xl lg:text-[10rem] leading-[0.85] tracking-tighter mb-6">
                Brand strategist.<br />
                <span className="italic text-peach">Content architect.</span>
              </h1>
              <p className="text-xs uppercase tracking-[0.3em] text-ink/50 mb-12">
                — Con strumenti AI integrati nel flusso di lavoro.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-24 md:mt-32 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-ink/60 mb-4">— Filosofia</p>
              <h2 className="font-heading text-4xl md:text-5xl tracking-tight mb-8 leading-tight">
                Capire il <em className="text-peach">perché</em>, prima di scrivere il cosa.
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-7 space-y-8 text-ink/80 text-lg leading-relaxed">
            <Reveal delay={0.1}>
              <p>
                Lavoro meglio con imprese che hanno qualcosa di vero da dire e non sanno bene come dirlo. Non entro in un'azienda per gestire i social. Entro per capire perché quell'azienda esiste — e da lì, parto.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p>
                In quasi tre anni dentro Liquid Diamond ho imparato a fare le domande scomode. Quelle che spostano un brand dal "facciamo contenuti" al "abbiamo finalmente capito chi siamo". Poi sono diventato responsabile di progetti per Atelier Biasetto, Alajmo S.p.A., UQIDO — e ho visto cosa succede quando il posizionamento è solido.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p>
                Oggi unisco strategia, contenuti, AI e relazioni. Costruisco architetture editoriali per chi vende complessità — tech, food d'eccellenza, consulenza. E ogni tanto scrivo libri.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-32 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60">— Come lavoro</p>
          </div>
          <div className="col-span-12 md:col-span-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {[
              { n: "01", t: "Ascolto", d: "Sessioni profonde con founder e management. Documenti interni. Mercato. Concorrenti. Tutto." },
              { n: "02", t: "Architettura", d: "Definisco posizionamento, manifesto, pillar narrativi. Niente template. Solo verità tradotte." },
              { n: "03", t: "Esecuzione", d: "Coordino contenuti, eventi, ADV, personal brand. Misuro. Itero. Restituisco numeri concreti." },
              { n: "04", t: "Strumenti", d: "Uso strumenti AI selezionati per accelerare ricerca, produzione e analisi. Il posizionamento resta lavoro umano — l'AI comprime i tempi, non sostituisce il ragionamento." },
            ].map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div className="border-t border-ink pt-6">
                  <span className="num-index text-5xl text-peach">{s.n}</span>
                  <h3 className="font-heading text-3xl mt-4 mb-3">{s.t}</h3>
                  <p className="text-ink/70 text-sm leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-32">
        <Reveal>
          <Link
            to="/progetti"
            className="font-heading text-5xl md:text-7xl italic editorial-link text-ink hover:text-peach transition-colors"
          >
            → Guarda i progetti
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
